
import AdminAboutEditor from "./AdminAboutEditor";
import AdminTaglineEditor from "./AdminTaglineEditor";
import AdminProjectsEditor from "./AdminProjectsEditor";
import AdminNewsletterForm from "./AdminNewsletterForm";
import AdminHeaderEditor from "./AdminHeaderEditor";
import AdminFeaturedButtonsEditor from "./AdminFeaturedButtonsEditor";

export default function AdminPublicSiteEditor() {
    return (
        <div className="container">
            <div className="mb-3">
                <AdminHeaderEditor />
            </div>
            <hr className="my-4" />
            <div className="mb-3">
                <AdminFeaturedButtonsEditor />
            </div>
            <hr className="my-4" />
            <div className="mb-3">
                <AdminTaglineEditor />
            </div>
            <hr className="my-4" />
            <div className="mb-3">
                <AdminAboutEditor />
            </div>
            <hr className="my-4" />
            <div className="mb-3">
                <AdminProjectsEditor />
            </div>
            <hr className="my-4" />
            <div className="mb-3">
                <AdminNewsletterForm />
            </div>
        </div>
    );
}